export default __webpack_public_path__ + "static/media/mobile-preview.9f6841c8.gif";